// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__IP7-C","noInteraction":"EventWrapper_noInteraction__1Rw7n","pointerPassthrough":"EventWrapper_pointerPassthrough__3V8gI"};